<template>
  <v-app class="app">
    <LibAuthHeader />
    <v-main :class="{ isMobile: isMobile }">
      <div class="content-padd-s">
        <div class="content-width layout">
          <div class="layout-left">
            <v-slide-x-transition mode="out-in">
              <router-view />
            </v-slide-x-transition>
          </div>
          <div class="layout-right" v-if="!isMobile">
            <div>
              <img
                class="banner-img block"
                alt="Banner EDB"
                src="/img/banner-auth.svg"
              />
            </div>
          </div>
        </div>
      </div>
      <CookieBanner></CookieBanner>
    </v-main>
    <LibFooter />
  </v-app>
</template>

<script>
import CookieBanner from "./components/CookieBanner.vue";
import LibAuthHeader from "@/components/library/layout/LibAuthHeader.vue";
import LibFooter from "@/components/library/layout/LibFooter.vue";
export default {
  name: "App",
  components: { LibAuthHeader, LibFooter, CookieBanner },
  data: () => ({}),
  created() {
    this.$store.dispatch("conf/load", ["password.strength"]);
  }
};
</script>

<style scoped lang="scss">
.app {
  background: #f5f5fa;
}
.layout {
  margin: auto;
  display: flex;
  gap: 20px;
  > div {
    flex: 1 0;
  }
}
.layout-right {
  display: flex;
  justify-content: center;
  .banner-img {
    display: block;
    max-width: 573px;
    width: 90%;
  }
}
.layout-left,
.layout-right {
  position: relative;
}
</style>
